/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import Linkify from 'react-linkify';

import Localized from '../../../../shared/components/Localized';
import { StatusIcon } from '../../SVGIcon';
import { TIMESTAMP_FORMAT } from "../../../../shared/utils/dates";
import FooterTimeStamp from '../../FooterTimestamp';

import { Wrapper, TitleWrapper, Title, TimeStamp, Body } from './styles.js';

const StatusIconWithMargin = styled(StatusIcon)`
  margin-right: 0.5rem;
`;

const ImpactStart = ({ feedItem, region, missingTranslations }) => (
  <Linkify properties={{ target: '_blank' }}>
    <Wrapper severity={feedItem.severity}>
      <TitleWrapper>
        <div>
          <StatusIconWithMargin
            severity={feedItem.severity} size='1.25rem'
          />
          <Title>
            <Localized
              modelName='incidentImpactType'
              modelKey={feedItem.impact.type}
              modelAttribute='serviceIssue'
              missingTranslations={missingTranslations}
            />&nbsp;
            <Localized
              modelName='beginString'
              modelKey= 'beginStringTranslation'
              modelAttribute='beginStringValue'
              missingTranslations={missingTranslations}
            />
          </Title>
        </div>
        <TimeStamp severity={feedItem.severity}>
          { moment.tz(feedItem.dateTime, region).format(TIMESTAMP_FORMAT) }
        </TimeStamp>
      </TitleWrapper>
      <Body>
        <Localized
          modelName='incidentImpactType'
          modelKey={feedItem.impact.type}
          modelAttribute='endUserImpact'
          missingTranslations={missingTranslations}
          hasLinks
        />
      </Body>
      <FooterTimeStamp 
        createdTime= {feedItem.postTime}
        lastModifiedTime={feedItem.postUpdatedTime}
        region= {region} 
        missingTranslations={missingTranslations}
      />
    </Wrapper>
  </Linkify>
);

export default ImpactStart;
